import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import TextInput from 'components/TextInput';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import OnboardingVector from 'assets/vectors/Onboarding.svg';
import CountryCodes from 'assets/json/countries.json';
import { useAppDispatch } from 'hooks/useStore';
import { signIn } from 'store/user';
import { setAlert, setError } from 'store/error';
import './index.css';

const GENDERS = [
    'Male',
    'Female',
    'Prefer not to say'
];

function Onboarding() {
    const defaultCountry = CountryCodes.find(country => country.isoCode === 'US');

    const [step, setStep] = useState(1);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [country, setCountry] = useState(
        <div className='onboarding__country' id={defaultCountry.isoCode}>
            <img src={defaultCountry.flag} />
            &nbsp;&nbsp;
            <p>{defaultCountry.name}</p>
        </div>
    );
    // const [birthDate, setBirthDate] = useState('');
    // const [gender, setGender] = useState('');
    // const [country, setCountry] = useState(
    //     <div className='onboarding__country' id={defaultCountry.isoCode}>
    //         <img src={defaultCountry.flag} />
    //         &nbsp;&nbsp;
    //         <p>{defaultCountry.dialCode}</p>
    //         &nbsp;&nbsp;
    //         <p>{defaultCountry.name}</p>
    //     </div>
    // );
    // const [countryCode, setCountryCode] = useState(defaultCountry.isoCode);
    // const [phoneNumber, setPhoneNumber] = useState('');
    // const [parentFirstName, setParentFirstName] = useState('');
    // const [parentLastName, setParentLastName] = useState('');
    // const [parentEmail, setParentEmail] = useState('');
    // const [parentPhoneNumber, setParentPhoneNumber] = useState('');
    // const [highSchool, setHighSchool] = useState('');
    // const [classOf, setClassOf] = useState('');
    // const [postalCode, setPostalCode] = useState('');

    const dispatch = useAppDispatch();

    // const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    //     event.preventDefault();
    //     if (step === 1) {
    //         if (firstName && lastName && birthDate && gender && phoneNumber) {
    //             if (checkIsAdult(birthDate)) {
    //                 setStep(3);
    //             }
    //             else {
    //                 setStep(2);
    //             }
    //         }
    //     }
    //     else if (step === 2) {
    //         if (parentFirstName && parentLastName && parentEmail && parentPhoneNumber) {
    //             setStep(3);
    //         }
    //     }
    //     else {
    //         if (highSchool && classOf && postalCode) {
    //             axios.post('students/sign-up/', {
    //                     firstName: firstName,
    //                     lastName: lastName,
    //                     countryCode: countryCode,
    //                     phoneNumber: phoneNumber,
    //                     gender: gender,
    //                     birthDate: birthDate,
    //                     parentInfo: checkIsAdult(birthDate) ? null : {
    //                         firstName: parentFirstName,
    //                         lastName: parentLastName,
    //                         email: parentEmail,
    //                         phoneNumber: parentPhoneNumber
    //                     },
    //                     highSchool: highSchool,
    //                     classOf: classOf,
    //                     postalCode: postalCode
    //                 })
    //                 .then(res => {
    //                     // console.log(res.data);
    //                     dispatch(signIn(res.data?.user));

    //                     ReactGA.event('sign_up');
    //                 })
    //                 .catch(error => {
    //                     // console.log(error);
    //                     dispatch(setError(error));
    //                 });
    //         }
    //     }
    // }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        
        if (firstName && lastName && country) {
            axios.post('students/sign-up/', {
                    firstName: firstName,
                    lastName: lastName,
                    countryCode: country?.props.id,
                    phoneNumber: null,
                    gender: null,
                    birthDate: null,
                    parentInfo: null,
                    highSchool: null,
                    classOf: null,
                    postalCode: null
                })
                .then(res => {
                    // console.log(res.data);
                    dispatch(signIn(res.data?.user));

                    ReactGA.event('sign_up');
                })
                .catch(error => {
                    // console.log(error);
                    dispatch(setError(error));
                });
        }
        else {
            dispatch(setAlert({
                response: {
                    data: {
                        message: 'Please fill in all the required fields.'
                    }
                }
            }));
        }
    }

    // const checkIsAdult = (dateString: string) => {
    //     const today = new Date();
    //     const birthday = new Date(dateString);
    //     const monthDiff = today.getMonth() - birthday.getMonth();

    //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthday.getDate())) {
    //         return today.getFullYear() - birthday.getFullYear() - 1 >= 18;
    //     }
    //     else {
    //         return today.getFullYear() - birthday.getFullYear() >= 18;
    //     }
    // }

    // const buttonDisabled = step === 1
    //     ? (!firstName || !lastName || !birthDate || !gender || !phoneNumber)
    //     : step === 2
    //     ? (!parentFirstName || !parentLastName || !parentEmail || !parentPhoneNumber)
    //     : step === 3
    //     ? (!highSchool || !classOf || !postalCode)
    //     : false;

    return (
        <div className='layout'>
            <Helmet
                title='Complete Sign Up - The SAT Crash Course'
                description='Create an account to get access to a free SAT practice test and to purchase courses of The SAT Crash Course and new digital SAT practice tests.'
            />
            <form className='onboarding' onSubmit={handleSubmit}>
                <img
                    className='onboarding__vector'
                    src={OnboardingVector}
                    alt='Onboarding'
                />
                <h1 className='onboarding__header'>
                    Tell us more about you
                </h1>
                {step === 1 &&
                    <>
                        <div className='onboarding__formGrid'>
                            <TextInput
                                className='onboarding__formGridItem'
                                name='firstName'
                                label='First name'
                                onChange={(event) => setFirstName(event.target.value)}
                                required
                                type='text'
                                value={firstName}
                            />
                            <TextInput
                                className='onboarding__formGridItem'
                                name='lastName'
                                label='Last name'
                                onChange={(event) => setLastName(event.target.value)}
                                required
                                type='text'
                                value={lastName}
                            />
                        </div>
                        <Dropdown
                            data={CountryCodes.map(country => (
                                <div className='onboarding__country' id={country.isoCode}>
                                    <img src={country.flag} />
                                    &nbsp;&nbsp;
                                    <p>{country.name}</p>
                                </div>
                            ))}
                            onSelect={(value) => setCountry(value)}
                            label='Country'
                            required
                            value={country}
                        />
                        {/* <div className='onboarding__formGrid'>
                            <TextInput
                                className='onboarding__formGridItem'
                                name='birthDate'
                                label='Date of birth'
                                onChange={(event) => setBirthDate(event.target.value)}
                                required
                                type='date'
                                value={birthDate}
                            />
                            <Dropdown
                                className='onboarding__formGridItem'
                                data={GENDERS}
                                onSelect={(value) => setGender(value)}
                                label='Gender'
                                required
                                value={gender}
                            />
                        </div>
                        <Dropdown
                            data={CountryCodes.map(country => (
                                <div className='onboarding__country' id={country.isoCode}>
                                    <img src={country.flag} />
                                    &nbsp;&nbsp;
                                    <p>{country.dialCode}</p>
                                    &nbsp;&nbsp;
                                    <p>{country.name}</p>
                                </div>
                            ))}
                            onSelect={(value) => {
                                setCountryCode(value.props.id);
                                setCountry(value);
                            }}
                            label='Country Code'
                            required
                            value={country}
                        />
                        <TextInput
                            name="phoneNumber"
                            label="Mobile number"
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 15) setPhoneNumber(value);
                            }}
                            required
                            type='text'
                            value={phoneNumber}
                        /> */}
                    </>
                }
                {/* {step === 2 &&
                    <>
                        <TextInput
                            name='parentFirstName'
                            label={`Parent's first name`}
                            onChange={(event) => setParentFirstName(event.target.value)}
                            required
                            type='text'
                            value={parentFirstName}
                        />
                        <TextInput
                            name='parentLastName'
                            label={`Parent's last name`}
                            onChange={(event) => setParentLastName(event.target.value)}
                            required
                            type='text'
                            value={parentLastName}
                        />
                        <TextInput
                            name='parentEmail'
                            label={`Parent's email`}
                            onChange={(event) => setParentEmail(event.target.value)}
                            required
                            type='email'
                            value={parentEmail}
                        />
                        <TextInput
                            name='parentPhoneNumber'
                            label={`Parent's phone number`}
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 10) setParentPhoneNumber(value);
                            }}
                            required
                            type='text'
                            value={parentPhoneNumber}
                        />
                    </>
                } */}
                {/* {step === 3 &&
                    <>
                        <TextInput
                            name='highSchool'
                            label='High school'
                            onChange={(event) => setHighSchool(event.target.value)}
                            required
                            type='text'
                            value={highSchool}
                        />
                        <div className='onboarding__formGrid'>
                            <Dropdown
                                className='onboarding__formGridItem'
                                data={[...Array(50)].map((_, i) => new Date().getFullYear() + 5 - i)}
                                onSelect={(value) => setClassOf(value)}
                                label='Class of'
                                required
                                value={classOf}
                            />
                            <TextInput
                                className='onboarding__formGridItem'
                                name='postalCode'
                                label='Zip code'
                                onChange={(event) => {
                                    const value = event.target.value.replace(/[^\d]/g, '');
                                    if (value.length <= 12) setPostalCode(value);
                                }}
                                required
                                type='text'
                                value={postalCode}
                            />
                        </div>
                    </>
                } */}
                <Button 
                    className='onboarding__button'
                    // disabled={buttonDisabled}
                    fullWidth
                    // secondary={buttonDisabled}
                    type='submit'
                >
                    NEXT
                </Button>
            </form>
        </div>
    );
}

export default Onboarding;